import React, { useState } from "react"
import { SeasonPanel } from "../../components/admin/SeasonsPanel"
import { SeasonEnrollmentsPanel } from "../../components/admin/SeasonEnrollmentsPanel"
import { TournamentsPanel } from "../../components/admin/TournamentsPanel"
import { UsersPanel } from "../../components/admin/UsersPanel"
import { EventLocationsPanel } from "../../components/admin/EventLocationsPanel"
import { Button } from "../../components/common/Button";
import { useAuth } from "../../contexts/AuthContext";

type Tab = "seasons" | "tournaments" | "users" | "event-locations" | "season-enrollments"

export const AdminPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>("seasons")
  const { user } = useAuth();

  const tabTitles: Record<Tab, string> = {
    "users": "Utenti",
    "seasons": "Stagioni",
    "tournaments": "Tornei",
    "event-locations": "Luoghi Eventi",
    "season-enrollments": "Iscrizioni"
  }
  const listTabs: Tab[] = ["seasons", "season-enrollments", "tournaments", "event-locations"]
  if (user && user.can_manage_all) {
    listTabs.push("users");
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Panel</h1>

      {/* Tabs */}
      <div className="flex overflow-x-auto mb-4 space-x-2 scrollbar-hide">
        {listTabs.map((tab) => (
          <Button
            key={tab}
            className="flex-shrink-0 whitespace-nowrap"
            size="lg"
            variant={activeTab === tab ? "primary" : "secondary"}
            onClick={() => setActiveTab(tab)}
          >
            {tabTitles[tab]}
          </Button>
        ))}
      </div>


      {/* Tab content */}
      <div className="p-4 border border-gray-300 rounded shadow bg-white">
        {activeTab === "users" && <UsersPanel />}
        {activeTab === "seasons" && <SeasonPanel />}
        {activeTab === "season-enrollments" && <SeasonEnrollmentsPanel />}
        {activeTab === "tournaments" && <TournamentsPanel />}
        {activeTab === "event-locations" && <EventLocationsPanel />}
      </div>
    </div>
  )
}
